var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2539 9.82701L6.4899 40.5929C6.16902 41.1485 6.00006 41.7788 6 42.4204C5.99994 43.062 6.16879 43.6923 6.48956 44.2479C6.81034 44.8035 7.27175 45.265 7.82739 45.5857C8.38303 45.9065 9.01333 46.0754 9.65493 46.0753H45.18C45.8216 46.0754 46.4519 45.9065 47.0076 45.5857C47.5632 45.265 48.0246 44.8035 48.3454 44.2479C48.6662 43.6923 48.835 43.062 48.835 42.4204C48.8349 41.7788 48.666 41.1485 48.3451 40.5929L30.583 9.82701C30.2623 9.27152 29.801 8.81025 29.2455 8.48954C28.69 8.16884 28.0599 8 27.4184 8C26.777 8 26.1469 8.16884 25.5914 8.48954C25.0359 8.81025 24.5746 9.27152 24.2539 9.82701Z",
    fill: "#EE404C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6502 19.3154H27.1868C26.0459 19.3154 25.1211 20.2403 25.1211 21.3811V31.2547C25.1211 32.3955 26.0459 33.3204 27.1868 33.3204H27.6502C28.791 33.3204 29.7158 32.3955 29.7158 31.2547V21.3811C29.7158 20.2403 28.791 19.3154 27.6502 19.3154Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4185 41.1514C28.6873 41.1514 29.7158 40.1228 29.7158 38.854C29.7158 37.5852 28.6873 36.5566 27.4185 36.5566C26.1497 36.5566 25.1211 37.5852 25.1211 38.854C25.1211 40.1228 26.1497 41.1514 27.4185 41.1514Z",
    fill: "#FFF7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/ExclamationIcon.722dca9613cbff254649fd43170ff950.svg";
export { ForwardRef as ReactComponent };